import { diffConfigurationObject } from "./diffConfigurationObject";
export function diffConfiguration(previous, next, shouldDiff = true) {
    var _a;
    if (!shouldDiff) {
        return next;
    }
    if (previous == null || next == null) {
        return next;
    }
    const objects = (_a = next.objects) === null || _a === void 0 ? void 0 : _a.map((object) => {
        var _a;
        // find the previous object matching with the same path
        const previousObject = (_a = previous.objects) === null || _a === void 0 ? void 0 : _a.find((previousObject) => previousObject.path === object.path);
        // if there is no previous object, we can just return the next object
        if (previousObject == null) {
            return object;
        }
        // merge the objects
        return diffConfigurationObject(previousObject, object);
    });
    return Object.assign(Object.assign({}, next), { objects });
}
//# sourceMappingURL=diffConfiguration.js.map